import Vue from 'vue'
import Vuex from 'vuex'
import partAnalysis from './modules/Part'

Vue.use(Vuex)

const state = {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'a1.png',
    drawer: null,
    darkTheme: false,
    memNowDoc: '',
    memNowHTML: '',
    dspEditDoc: '',
    textareaRef: '',
    watchImage: '',
    isDisplayDoc: 'inherit',
}

const getters = {
  darkTheme: state => { return state.darkTheme },
}

const mutations = {
  SET_BAR_IMAGE (state, payload) { state.barImage = payload },
  SET_DRAWER (state, payload) { state.drawer = payload },
  changeEdtorHTML (state, argCont) {
    state.dspEditDoc = argCont.replace(/\r?\n/g, '<br>').replace(new RegExp('　', 'g'), '<span style="position:relative">　</span>')
  },
}

export default new Vuex.Store({
  namespased: true,
  state,
  getters,
  mutations,
  modules: {
    partAnalysis,
  },
  head: {
    meta: [
      { name: 'description', content: '品詞の解析、括弧の解析、特許関連文書の校正が可能です。' },
      { property: 'og:title', content: 'Document Checker -特許明細書-' },
      { property: 'og:description', content: '品詞の解析、括弧の解析、特許関連文書の校正が可能です。' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://document-checker-project.web.app/' },
      { property: 'og:image', content: 'https://document-checker-project.web.app/favicon.ico' },
      { name: 'twitter:card', content: 'summary' },
    ],
  },
})
